import MicrosoftAnchor from './MicrosoftAnchor';

export default MicrosoftAnchor;
